import double1 from "../../images/Rooms/DoubleTwin/dt1.jpg";
import double2 from "../../images/Rooms/DoubleTwin/dt2.jpg";
import double3 from "../../images/Rooms/DoubleTwin/dt3.jpg";
import double4 from "../../images/Rooms/DoubleTwin/dt4.jpg";
import double5 from "../../images/Rooms/DoubleTwin/dt5.jpg";

import triple1 from "../../images/Rooms/TripleQuadruple/t1.jpg";
import triple2 from "../../images/Rooms/TripleQuadruple/t2.jpg";

import family1 from "../../images/Rooms/FamilyRoom/fr1.jpg";
import family2 from "../../images/Rooms/FamilyRoom/fr2.jpg";
import family3 from "../../images/Rooms/FamilyRoom/fr3.jpg";
import family4 from "../../images/Rooms/FamilyRoom/fr4.jpg";
import family5 from "../../images/Rooms/FamilyRoom/fr5.jpg";
import family6 from "../../images/Rooms/FamilyRoom/fr6.jpg";

import apartments1 from "../../images/Rooms/Apartment/a3.jpg";
import apartments2 from "../../images/Rooms/Apartment/a4.jpg";
import apartments3 from "../../images/Rooms/Apartment/a5.jpg";
import apartments4 from "../../images/Rooms/Apartment/a7.jpg";
import apartments5 from "../../images/Rooms/Apartment/a8.jpg";
// import apartments6 from "../../images/Rooms/Apartment/a9.jpg";
import apartments7 from "../../images/Rooms/Apartment/a11.jpg";
import apartments8 from "../../images/Rooms/Apartment/a12.jpg";
import apartments9 from "../../images/Rooms/Apartment/a13.jpg";
import apartments10 from "../../images/Rooms/Apartment/a14.jpg";


import blue_house4 from "../../images/Houses/BlueHouse/new/bh.jpg";
import blue_house5 from "../../images/Houses/BlueHouse/new/bh4.jpg";
import blue_house2 from "../../images/Houses/BlueHouse/bh2.jpg";
import blue_house3 from "../../images/Houses/BlueHouse/bh4.jpg";
import blue_house from "../../images/Houses/BlueHouse/bh6.jpg";
import blue_house7 from "../../images/Houses/BlueHouse/bh7.jpg";
import blue_house8 from "../../images/Houses/BlueHouse/new/bh5.jpg";
import blue_house9 from "../../images/Houses/BlueHouse/new/bh6.jpg";
import blue_house10 from "../../images/Houses/BlueHouse/new/bh7.jpg";
import blue_house11 from "../../images/Houses/BlueHouse/new/bh8.jpg";
import blue_house12 from "../../images/Houses/BlueHouse/new/bh9.jpg";
import blue_house13 from "../../images/Houses/BlueHouse/new/bh10.jpg";

import green_house2 from "../../images/view-gallery/houses/GreenHouse/gh1.jpg";
import green_house3 from "../../images/view-gallery/houses/GreenHouse/GH_kitchen.jpg";
import green_house4 from "../../images/view-gallery/houses/GreenHouse/GreenHouse1.jpg";
import green_house6 from "../../images/view-gallery/houses/GreenHouse/Greenhouse_Outside.jpg";
import green_house7 from "../../images/view-gallery/houses/GreenHouse/GH_bathroom.jpg";

import grotta_northern_lights from "../../images/Houses/GNL/gnl1.jpg";
import grotta_northern_lights2 from "../../images/Houses/GNL/gnl2.jpg";
import grotta_northern_lights3 from "../../images/Houses/GNL/gnl3.jpg";
import grotta_northern_lights4 from "../../images/Houses/GNL/gnl4.jpg";
import grotta_northern_lights5 from "../../images/Houses/GNL/gnl5.jpg";
import grotta_northern_lights6 from "../../images/Houses/GNL/gnl6.jpg";
import grotta_northern_lights7 from "../../images/Houses/GNL/gnl7.jpg";
import grotta_northern_lights8 from "../../images/Houses/GNL/gnl8.jpg";
import grotta_northern_lights10 from "../../images/Houses/GNL/gnl9.png";
import grotta_northern_lights9 from "../../images/Houses/GNL/gnl10.jpg";
//
import neighborhoodPic1 from "../../images/view-gallery/neighborhood.jpeg";
import neighborhoodPic2 from "../../images/view-gallery/neighborhood2.jpg";
import neighborhoodPic3 from "../../images/view-gallery/neighborhood3.jpg";

import northernLightsPic3 from "../../images/Surroundings/surrounding3.jpg";
import NorthernLightsPic1 from "../../images/view-gallery/northern_lights.jpeg";
import northernLightsPic2 from "../../images/view-gallery/northern_lights3.jpg";

import activitiesPic from "../../images/view-gallery/Activities/1.jpg";
import activitiesPic2 from "../../images/view-gallery/Activities/2.jpg";
import activitiesPic3 from "../../images/view-gallery/Activities/3.jpg";
import Activites4 from "../../images/view-gallery/Activities/4.jpg";

export const doubleRoom = [
  {
    id: 1,
    title: "Double/Twin",
    background: double1,
    description:
      "Our double/twin rooms are available at 3 of our properties. Facing the seaside, the rooms are equipped with a king-size or twin bed and Netflix TV. Some rooms offer shared bathroom and kitchen facilities.",
  },
  {
    id: 2,
    title: "Double/Twin",
    background: double2,
    description:
      "Our double/twin rooms are available at 3 of our properties. Facing the seaside, the rooms are equipped with a king-size or twin bed and Netflix TV. Some rooms offer shared bathroom and kitchen facilities.",
  },
  {
    id: 3,
    title: "Double/Twin",
    background: double3,
    description:
      "Our double/twin rooms are available at 3 of our properties. Facing the seaside, the rooms are equipped with a king-size or twin bed and Netflix TV. Some rooms offer shared bathroom and kitchen facilities.",
  },
  {
    id: 4,
    title: "Double/Twin",
    background: double4,
    description:
      "Our double/twin rooms are available at 3 of our properties. Facing the seaside, the rooms are equipped with a king-size or twin bed and Netflix TV. Some rooms offer shared bathroom and kitchen facilities.",
  },
  {
    id: 5,
    title: "Double/Twin",
    background: double5,
    description:
      "Our double/twin rooms are available at 3 of our properties. Facing the seaside, the rooms are equipped with a king-size or twin bed and Netflix TV. Some rooms offer shared bathroom and kitchen facilities.",
  },
];
export const tripleRoom = [
  {
    id: 1,
    title: "Triple / Quadruple",
    background: triple1,
    description:
      "The Triple/Quadruple Rooms are located in two of the three buildings. They feature a sofa bed and flat screen TVs with Netflix. Twin beds can be requested depending on availability. Bathroom and kitchen facilities are shared.",
  },
  {
    id: 2,
    title: "Triple / Quadruple",
    background: triple2,
    description:
      "The Triple/Quadruple Rooms are located in two of the three buildings. They feature a sofa bed and flat screen TVs with Netflix. Twin beds can be requested depending on availability. Bathroom and kitchen facilities are shared.",
  },
];
export const familyRoom = [
  {
    id: 1,
    title: "Family Room",
    background: family1,
    description:
      "The Family Room with a terrace overlooking the ocean and the lighthouse is located in the Grótta Northern Lights Apartment in Valhúsabraut 35. It includes a TV with Netflix, as well as a private bathroom and dining area. Kitchen facilities are shared.",
  },
  {
    id: 2,
    title: "Family Room",
    background: family2,
    description:
      "The Family Room with a terrace overlooking the ocean and the lighthouse is located in the Grótta Northern Lights Apartment in Valhúsabraut 35. It includes a TV with Netflix, as well as a private bathroom and dining area. Kitchen facilities are shared.",
  },
  {
    id: 3,
    title: "Family Room",
    background: family3,
    description:
      "The Family Room with a terrace overlooking the ocean and the lighthouse is located in the Grótta Northern Lights Apartment in Valhúsabraut 35. It includes a TV with Netflix, as well as a private bathroom and dining area. Kitchen facilities are shared.",
  },
  {
    id: 4,
    title: "Family Room",
    background: family4,
    description:
      "The Family Room with a terrace overlooking the ocean and the lighthouse is located in the Grótta Northern Lights Apartment in Valhúsabraut 35. It includes a TV with Netflix, as well as a private bathroom and dining area. Kitchen facilities are shared.",
  },
  {
    id: 5,
    title: "Family Room",
    background: family5,
    description:
      "The Family Room with a terrace overlooking the ocean and the lighthouse is located in the Grótta Northern Lights Apartment in Valhúsabraut 35. It includes a TV with Netflix, as well as a private bathroom and dining area. Kitchen facilities are shared.",
  },
  {
    id: 6,
    title: "Family Room",
    background: family6,
    description:
      "The Family Room with a terrace overlooking the ocean and the lighthouse is located in the Grótta Northern Lights Apartment in Valhúsabraut 35. It includes a TV with Netflix, as well as a private bathroom and dining area. Kitchen facilities are shared.",
  },
];
export const apartmentRoom = [
  // {
  //   id: 1,
  //   title: "Apartments",
  //   background: apartments,
  //   description:
  //     "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  // },
  {
    id: 1,
    title: "Apartments",
    background: apartments1,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
  {
    id: 2,
    title: "Apartments",
    background: apartments2,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
  {
    id: 3,
    title: "Apartments",
    background: apartments3,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },

  {
    id: 4,
    title: "Apartments",
    background: apartments4,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
  {
    id: 5,
    title: "Apartments",
    background: apartments5,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
  {
    id: 6,
    title: "Apartments",
    background: apartments5,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
  {
    id: 7,
    title: "Apartments",
    background: apartments7,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
  {
    id: 8,
    title: "Apartments",
    background: apartments8,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
  {
    id: 9,
    title: "Apartments",
    background: apartments9,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
  {
    id: 10,
    title: "Apartments",
    background: apartments10,
    description:
      "Our two-bedroom apartment is located in the garden of the Blue House, while our three-bedroom apartment with sea view is located 150 metres from it. Both are equipped with a kitchenette, private bathrooms, sofa beds and Netflix TVs.",
  },
];

export const blueHouse = [
  {
    id: 1,
    title: "Blue House",
    background: blue_house,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 2,
    title: "Blue House",
    background: blue_house2,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 3,
    title: "Blue House",
    background: blue_house3,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 4,
    title: "Blue House",
    background: blue_house4,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 5,
    title: "Blue House",
    background: blue_house5,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 6,
    title: "Blue House",
    background: blue_house7,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 7,
    title: "Blue House",
    background: blue_house8,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 8,
    title: "Blue House",
    background: blue_house9,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 9,
    title: "Blue House",
    background: blue_house10,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 10,
    title: "Blue House",
    background: blue_house11,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 11,
    title: "Blue House",
    background: blue_house12,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
  {
    id: 12,
    title: "Blue House",
    background: blue_house13,
    description:
      "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 10 minutes by car from the city of Reykjavik.",
  },
];
export const greenHouse = [
  {
    id: 1,
    title: "Green House",
    background: green_house2,
    description:
      "The two-bedroom apartment called Green House is located in the garden of the Blue House. It is perfect for solo travellers or small groups of friends looking for a peaceful getaway. It features a kitchenette, a living area and a bathroom with shower.",
  },
  {
    id: 2,
    title: "Green House",
    background: green_house3,
    description:
      "The two-bedroom apartment called Green House is located in the garden of the Blue House. It is perfect for solo travellers or small groups of friends looking for a peaceful getaway. It features a kitchenette, a living area and a bathroom with shower.",
  },
  {
    id: 3,
    title: "Green House",
    background: green_house4,
    description:
      "The two-bedroom apartment called Green House is located in the garden of the Blue House. It is perfect for solo travellers or small groups of friends looking for a peaceful getaway. It features a kitchenette, a living area and a bathroom with shower.",
  },
  {
    id: 5,
    title: "Green House",
    background: green_house6,
    description:
      "The two-bedroom apartment called Green House is located in the garden of the Blue House. It is perfect for solo travellers or small groups of friends looking for a peaceful getaway. It features a kitchenette, a living area and a bathroom with shower.",
  },
  {
    id: 6,
    title: "Green House",
    background: green_house7,
    description:
      "The two-bedroom apartment called Green House is located in the garden of the Blue House. It is perfect for solo travellers or small groups of friends looking for a peaceful getaway. It features a kitchenette, a living area and a bathroom with shower.",
  },
];
export const grottaNorthernLights = [
  {
    id: 1,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 2,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights2,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 3,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights3,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 4,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights4,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 5,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights5,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 6,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights6,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 7,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights7,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 8,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights8,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 9,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights9,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
  {
    id: 10,
    title: "Grótta Northern Lights Apartment",
    background: grotta_northern_lights10,
    description:
      "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
];

export const northernLights = [
  {
    id: 1,
    title: "Northern Lights",
    background: NorthernLightsPic1,
    description:
      "Close to the Blue House, the best place to spot northern lights is by Grótta Lighthouse. Located on the edge of Seltjarnarnes Peninsula in a protected nature reserve home to more than 100 different bird species and 140 plant varieties, the lighthouse was built in 1897 and fully restored in 1947. You can easily reach it with a pleasant 25-minutes walk from the Blue House.",
  },
  {
    id: 2,
    title: "Northern Lights",
    background: northernLightsPic2,
    description:
      "Close to the Blue House, the best place to spot northern lights is by Grótta Lighthouse. Located on the edge of Seltjarnarnes Peninsula in a protected nature reserve home to more than 100 different bird species and 140 plant varieties, the lighthouse was built in 1897 and fully restored in 1947. You can easily reach it with a pleasant 25-minutes walk from the Blue House.",
  },
  {
    id: 3,
    title: "Northern Lights",
    background: northernLightsPic3,
    description:
      "Close to the Blue House, the best place to spot northern lights is by Grótta Lighthouse. Located on the edge of Seltjarnarnes Peninsula in a protected nature reserve home to more than 100 different bird species and 140 plant varieties, the lighthouse was built in 1897 and fully restored in 1947. You can easily reach it with a pleasant 25-minutes walk from the Blue House.",
  },
];
export const neighborhood = [
  {
    id: 1,
    title: "Neighborhood",
    background: neighborhoodPic1,
    // "https://i2.wp.com/bluehouse.is/wp-content/uploads/2020/04/rsz_1contactus-e1608110467521.jpg?fit=1000%2C563&ssl=1",
    description:
      "Seltjarnarnes is a very quiet town: you will definitely have a very relaxing stay with us! You will often see kids playing or running in the streets, parents walking with their toddlers, and cute, furry cats strolling around undisturbed. Did you know that in 2007 Seltjarnarnes became the world's first town where every citizen had access to fiber optics?",
  },
  {
    id: 2,
    title: "Neighborhood",
    background: neighborhoodPic2,
    description:
      "Seltjarnarnes is a very quiet town: you will definitely have a very relaxing stay with us! You will often see kids playing or running in the streets, parents walking with their toddlers, and cute, furry cats strolling around undisturbed. Did you know that in 2007 Seltjarnarnes became the world's first town where every citizen had access to fiber optics?",
  },
  {
    id: 3,
    title: "Neighborhood",
    background: neighborhoodPic3,
    description:
      "Seltjarnarnes is a very quiet town: you will definitely have a very relaxing stay with us! You will often see kids playing or running in the streets, parents walking with their toddlers, and cute, furry cats strolling around undisturbed. Did you know that in 2007 Seltjarnarnes became the world's first town where every citizen had access to fiber optics?",
  },
];
export const activities = [
  {
    id: 1,
    title: "Activities",
    background: Activites4,
    description:
      "While visiting Seltjarnarnes Peninsula, stroll through Valhúsahæð Park, behind the Blue House, then head to the Grótta Lighthouse, located in a protected nature reserve. Don’t miss the Kvika Foot Bath, a geothermal small pool that allows you to enjoy the beautiful view of Esja Mountain and Snæfellsjökull Glacier.",
  },
  {
    id: 2,
    title: "Activities",
    background: activitiesPic,
    description:
      "While visiting Seltjarnarnes Peninsula, stroll through Valhúsahæð Park, behind the Blue House, then head to the Grótta Lighthouse, located in a protected nature reserve. Don’t miss the Kvika Foot Bath, a geothermal small pool that allows you to enjoy the beautiful view of Esja Mountain and Snæfellsjökull Glacier.",
  },
  {
    id: 3,
    title: "Activities",
    background: activitiesPic2,
    description:
      "While visiting Seltjarnarnes Peninsula, stroll through Valhúsahæð Park, behind the Blue House, then head to the Grótta Lighthouse, located in a protected nature reserve. Don’t miss the Kvika Foot Bath, a geothermal small pool that allows you to enjoy the beautiful view of Esja Mountain and Snæfellsjökull Glacier.",
  },
  {
    id: 4,
    title: "Activities",
    background: activitiesPic3,
    description:
      "While visiting Seltjarnarnes Peninsula, stroll through Valhúsahæð Park, behind the Blue House, then head to the Grótta Lighthouse, located in a protected nature reserve. Don’t miss the Kvika Foot Bath, a geothermal small pool that allows you to enjoy the beautiful view of Esja Mountain and Snæfellsjökull Glacier.",
  },
];

export const sliderData_Rooms = [
  {
    title: "Double/Twin",
    imagesAndDescription: doubleRoom,
  },
  {
    title: "Triple/Quadruple",
    imagesAndDescription: tripleRoom,
  },
  {
    title: "Family Room",
    imagesAndDescription: familyRoom,
  },
  {
    title: "Two-bedroom Apartment",
    imagesAndDescription: apartmentRoom,
  },
];

export const sliderData_Houses = [
  {
    title: "Blue House",
    imagesAndDescription: blueHouse,
  },
  {
    title: "Green House",
    imagesAndDescription: greenHouse,
  },
  {
    title: "Grótta Northern Lights",
    imagesAndDescription: grottaNorthernLights,
  },
];

export const sliderData_Surroundings = [
  {
    title: "Northern Lights",
    imagesAndDescription: northernLights,
  },
  {
    title: "Neighborhood",
    imagesAndDescription: neighborhood,
  },
  {
    title: "Activities",
    imagesAndDescription: activities,
  },
];

const sliderData = [
  sliderData_Rooms,
  sliderData_Houses,
  sliderData_Surroundings,
];
export { sliderData };
